import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router-dom'
import { config } from '../../config'
import {
  Button,
  Icon,
  Grid,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  ListItemSecondaryAction,
} from '@material-ui/core'
import {
  ToggleButton,
  ToggleButtonGroup,
} from '@material-ui/lab'
import { withStyles } from '@material-ui/core/styles'
import TripItinerary from '../../components/trip/TripItinerary.js'
import Cookies from 'universal-cookie'

const cookies = new Cookies();

const TRAVEL_STYLES = [
  {
    icon: 'add_circle_outline',
    title: 'Describe my own',
    value: 'new',
  },
]

class Planner extends Component {
  constructor(props) {
    super(props)

    this.state = {
      trip: null,
    }
  }


  render() {
    const { classes, user } = this.props
    const { travel, openedTab } = this.state

    return (
      <Fragment>
        <div style={{marginTop: 0}}>
          {this.state.trip &&
            <TripItinerary
              trip_id={this.state.trip.id}
              planned={this.state.trip.planned}
              user={this.props.user}
            />
          }
        </div>

      </Fragment>
    )
  }
}

const styles = theme => ({
  h3: {
    marginTop: 0,
  },
  subtitle: {
    fontWeight: 600,
    fontSize: 15,
    marginTop: 0,
    marginBottom: 20,
    textAlign: 'left',
    color: '#828282',
  },
  listItemIcon: {
    color: '#02c39a',
  },
  listItemText: {
    fontSize: 15,
    fontWeight: 600,
    color: '#000',
    maxWidth: '78%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextSecondary: {
    fontSize: 14,
    fontWeight: 600,
    maxWidth: '60%',
    display: 'block',
    overflow: 'hidden',
    // whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
  listItemTextPrice: {
    fontSize: 15,
    fontWeight: 600,
    maxWidth: '70%',
    display: 'block',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    cursor: 'pointer',

    '& .material-icons': {
      color: '#02c39a',
      fontWeight: 300,
      verticalAlign: 'middle',
      margin: '-3px 0px 0px 15px',
    }
  },
  listItemSelected: {
    borderRadius: 15,
    border: '1px solid #02c39a',
  },
  listItem: {
    borderRadius: 15,
    border: '1px solid transparent',

    '&:hover': {
      backgroundColor: '#07c3991a',
    },
  },
  buttonBook: {
    // float: 'right',
    color: '#fff',
    margin: '10px 0px',
    backgroundColor: '#02c39a',
    textTransform: 'none',
    boxShadow: 'none',
    borderRadius: 25,
    fontWeight: 800,
    padding: 15,
    width: '100%',

    '&:hover': {
      backgroundColor: 'rgb(1, 136, 107)',
      boxShadow: 'none',
    }
  },
  searchField: {
    border: '1px solid #f2f2f2',
    borderRadius: 20,
    marginBottom: 10,
    backgroundColor: '#fff',
  },
  iconLabel: {
    color: '#333',
    fontSize: 13,
    fontWeight: 700,
    marginBottom: -4,
    marginLeft: 5,
  },
  buttonOutlined: {
    // color: '#1bb746',
    float: 'left',
    // marginLeft: 10,
    padding: '10px',
    borderRadius: 25,
    fontWeight: 500,
    border: '1px solid #f5f5f5',
    color: '#333',
    marginTop: 6,
    minWidth: 110,
    backgroundColor: '#f5f5f5',

    '& .material-icons': {
      marginRight: 5,
      color: '#777',
      fontWeight: 500,
      padding: 0,
    },

    '&:hover': {
      backgroundColor: '#f2f2f2',
      border: '1px solid transparent',
    },

    '&:not(:first-child)': {
      marginLeft: 0,
    },

    '&:hover .material-icons': {
      color: '#333',
    },
  },
  buttonOutlinedSelected: {
    backgroundColor: '#f5f5f5 !important',
    fontWeight: 800,
    color: '#333 !important',
    padding: '5px 7px',
    minWidth: 110,

    '& .material-icons': {
      color: '#02c39a !important',
    },

    '&:hover': {
      color: '#333',
    },

    '&:hover .material-icons': {
      color: '#333',
    },

    '& > .MuiToggleButton-label': {
      borderRadius: 25,
      backgroundColor: '#fff',
      padding: '4px 10px',
      boxShadow: '0px 3px 3px -2px rgb(0 0 0 / 5%), 0px 3px 4px 0px rgb(0 0 0 / 5%), 0px 1px 8px 0px rgb(0 0 0 / 5%)',
    },
  },
})

export default withRouter(withStyles(styles)(Planner))
